export default {
    getHcResults() {
        return axios({
            url: `HcResults/get-hc-results`,
            method: 'GET'
        })
    },
};